export const ComposerDefinition = {
    id: 'Composer',
    name: 'Composer',
    prefix: 'composer',
    uri: 'http://composer.bimswarm.de/definition'
};
